import Vue from 'vue'

const state = {
  preBooking: null,
  professionalPreBookings: null
}

const actions = {
  LOAD_PRE_BOOKING_DETAIL: ({commit}, id) => {
    const url = 'pre-bookings/' + id
    Vue.http.get(url)
      .then(response => {
        return response.json()
      })
      .then(response => {
        console.log(response)
        if (!response.error) {
          commit('SET_PRE_BOOKING_DETAIL', response.pre_booking)
          commit('SET_PROFESSIONAL_PRE_BOOKINGS', response.professional_pre_bookings)
        }
      })
  }
}

const mutations = {
  SET_PRE_BOOKING_DETAIL: (state, preBooking) => {
    state.preBooking = preBooking
  },
  SET_PROFESSIONAL_PRE_BOOKINGS: (state, professionals) => {
    state.professionalPreBookings = professionals
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/pre.booking.js